import { axios } from '@/lib/axios'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

export const getZZZ6s = async (query) => {
  const { page, pageSize, sortBy = '', orderBy = 1, filters = {} } = query

  // Transform array filters to comma-separated strings for backend
  const transformedFilters = { ...filters }
  Object.keys(transformedFilters).forEach((key) => {
    if (Array.isArray(transformedFilters[key])) {
      transformedFilters[key] = transformedFilters[key].join(',')
    }
  })

  const params = {
    page,
    limit: pageSize,
    sortBy: sortBy || 'description',
    orderBy,
    ...transformedFilters,
  }
  const response = await axios.get('/ZZZ6s', { params })
  return response.data.result
}

export const createZZZ6 = async (data) => {
  const response = await axios.post('/ZZZ6s', data)
  return response.data
}

export const updateZZZ6 = async ({ id, data }) => {
  const response = await axios.put(`/ZZZ6s/${id}`, data)
  return response.data
}

export const deleteZZZ6 = async (id) => {
  const response = await axios.delete(`/ZZZ6s/${id}`)
  return response.data
}

export const uploadZZZ6s = async (file) => {
  const formData = new FormData()
  formData.append('file', file)
  const response = await axios.post('/ZZZ6s/upload', formData)
  return response.data
}

const getZZZ6CategoryOptions = (zzz6Response) => {
  if (!Array.isArray(zzz6Response?.data)) {
    return []
  }

  const categories = new Set()

  zzz6Response.data.forEach((zzz6) => {
    const rawCategories = zzz6?.Category

    if (Array.isArray(rawCategories)) {
      rawCategories.forEach((category) => {
        if (typeof category === 'string' && category.trim() !== '') {
          categories.add(category.trim())
        }
      })
      return
    }

    if (typeof rawCategories === 'string' && rawCategories.trim() !== '') {
      categories.add(rawCategories.trim())
    }
  })

  return Array.from(categories)
    .sort((left, right) => left.localeCompare(right))
    .map((category) => ({ value: category, label: category }))
}

const useZZZ6 = () => {
  const queryClient = useQueryClient()

  const useFetchAllZZZ6s = (query) => {
    return useQuery({
      queryKey: ['zzz6s', query],
      queryFn: () => getZZZ6s(query),
      onError: (error) => {
        toast.error(error?.response?.data?.message || 'Failed to fetch ZZZ6s')
      },
    })
  }

  const useFetchZZZ6CategoryOptions = (query) => {
    return useQuery({
      queryKey: ['zzz6s', query],
      queryFn: () => getZZZ6s(query),
      select: getZZZ6CategoryOptions,
      onError: (error) => {
        toast.error(error?.response?.data?.message || 'Failed to fetch ZZZ6 categories')
      },
    })
  }

  const useCreateZZZ6 = () => {
    return useMutation({
      mutationFn: createZZZ6,
      onSuccess: () => {
        queryClient.invalidateQueries(['zzz6s'])
        toast.success('ZZ6 created successfully')
      },
      onError: (error) => {
        toast.error(error?.response?.data?.message || 'Failed to create ZZZ6')
      },
    })
  }

  const useUpdateZZZ6 = () => {
    return useMutation({
      mutationFn: updateZZZ6,
      onSuccess: () => {
        queryClient.invalidateQueries(['zzz6s'])
        toast.success('ZZZ6 updated successfully')
      },
      onError: (error) => {
        toast.error(error?.response?.data?.message || 'Failed to update ZZZ6')
      },
    })
  }

  const useRemoveZZZ6 = () => {
    return useMutation({
      mutationFn: deleteZZZ6,
      onSuccess: () => {
        queryClient.invalidateQueries(['zzz6s'])
        toast.success('ZZZ6 deleted successfully')
      },
      onError: (error) => {
        toast.error(error?.response?.data?.message || 'Failed to delete ZZZ6')
      },
    })
  }

  const useUploadZZZ6s = () => {
    return useMutation({
      mutationFn: uploadZZZ6s,
      onSuccess: () => {
        queryClient.invalidateQueries(['zzz6s'])
        toast.success('ZZZ6s uploaded successfully')
      },
      onError: (error) => {
        toast.error(error?.response?.data?.message || 'Failed to upload ZZZ6s')
      },
    })
  }

  return {
    useFetchAllZZZ6s,
    useFetchZZZ6CategoryOptions,
    useCreateZZZ6,
    useUpdateZZZ6,
    useRemoveZZZ6,
    useUploadZZZ6s,
  }
}

export default useZZZ6
